module.exports = __webpack_public_path__ + "img/sisa_saldo.773f2a79.svg";